module.exports = __webpack_public_path__ + "img/logo1.c5aa84c4.png";